// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603271748/js/" + chunkId + "." + {"44":"495df906","225":"403f349d","481":"54544190","486":"d88d4ef3","770":"e5d7bc24"}[chunkId] + ".0.43519026830229657.chunk.js";
};